import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08eeed80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tit" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = { class: "cont-nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "table-block"
}
const _hoisted_7 = { class: "my-table" }
const _hoisted_8 = {
  border: "1",
  bordercolor: "#ccc"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  border: "1",
  class: "table-cont"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        ((_ctx.data || []).length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("b", null, _toDisplayString(_ctx.chartTit), 1),
                _createVNode(_component_a_popover, {
                  content: "点击下方表格内的指标名称行可切换查看该指标的历史趋势柱状图",
                  trigger: "hover",
                  overlayClassName: "tooltipstyle",
                  arrowPointAtCenter: "",
                  placement: "topLeft"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _createVNode(_component_Charts, {
                id: "NumberofShareholders",
                option: _ctx.option
              }, null, 8, ["option"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
              onClick: ($event: any) => (_ctx.checkTag(tag))
            }, _toDisplayString(tag.label), 11, _hoisted_5))
          }), 128))
        ]),
        ((_ctx.data || []).length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: _normalizeClass({active : item.key === _ctx.chartKey}),
                      onClick: ($event: any) => (_ctx.checkCurrent(item, _ctx.idx))
                    }, [
                      _createElementVNode("th", {
                        class: _normalizeClass({bold : item.dataIndex === 'time'})
                      }, [
                        _createTextVNode(_toDisplayString(item.title), 1),
                        (item.unit&&item.unit!=='%')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(item.unit) + ")", 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 10, _hoisted_9))
                  }), 128))
                ]),
                _createElementVNode("table", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, m) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass({active : item.key === _ctx.chartKey}),
                      key: m,
                      onClick: ($event: any) => (_ctx.checkCurrent(item, _ctx.idx))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, t) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: t,
                          style: {"width":"10%"},
                          class: _normalizeClass({bold : item.dataIndex === 'time'})
                        }, [
                          (item.slots && item.slots.customRender === 'peopleCount')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getNumber(td[item.key])), 1))
                            : (item.slots && item.slots.customRender === 'increase')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([
                td[item.key] > 0 ? 'red' : td[item.key] < 0 ? 'green' : ''
              ])
                                }, _toDisplayString(td[item.key] > 0 ? "+" : "") + _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                  ? (td[item.key] || 0).toFixed(2) + "%"
                  : "—"), 3))
                              : (
                item.slots && item.slots.customRender === 'nocolorincrease'
              )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                  ? (td[item.key] || 0).toFixed(2) + "%"
                  : "—"), 1))
                                : (item.slots && item.slots.customRender === 'decimal')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                  ? (td[item.key] || 0).toFixed(2)
                  : "—"), 1))
                                  : (item.slots && item.slots.customRender === 'decimal4')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                  ? (td[item.key] || 0).toFixed(4)
                  : "—"), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(td[item.key] || "—"), 1))
                        ], 2))
                      }), 128))
                    ], 10, _hoisted_12))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_18, [
              _createVNode(_component_Nodata, {
                nodatadesc: _ctx.itemdata.title
              }, null, 8, ["nodatadesc"])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}